module.exports = __webpack_public_path__ + "img/menu-item-off.53be93f3.svg";